/**
 * 将十六进制的颜色转换为 RGBA 格式
 * @param hex {String} 十六进制颜色格式，例如：#ffffff00
 * @returns {Array} RGBA 颜色，例如：[255, 255, 255, 255]
 */
export function hex2rgba(hex) {
  const result = [];
  for (let i = 1; i < hex.length; i += 2) {
    result.push(parseInt(hex[i] + hex[i + 1], 16));
  }
  return result;
}

/**
 * 根据背景色将 RGBA 颜色转换为 RGB 颜色
 * @param hex {String} 十六进制颜色格式，例如：#ffffff00
 * @param [bg] {Number} 背景颜色，例如 255
 * @returns {string} RGB 颜色，例如：rgb(255, 255, 255)
 */
export function rgba2rgb(hex, bg = 255) {
  let sources = hex2rgba(hex), alpha = sources[sources.length - 1] / 255;
  let result = [];
  for (let i = 0; i < 3; i++) {
    result.push(Math.round(((1 - alpha) * bg) + (alpha * sources[i])));
  }
  return 'rgb(' + result.join(', ') + ')';
}